var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-spin',{attrs:{"tip":_vm.spinnerLoaderLabel,"size":"large","spinning":_vm.spinnerLoader}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('servicesListComponent',{ref:"servicesListComponent"})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }